import { render, staticRenderFns } from "./Permits.vue?vue&type=template&id=a0558ad8&scoped=true"
import script from "./Permits.vue?vue&type=script&lang=js"
export * from "./Permits.vue?vue&type=script&lang=js"
import style0 from "./Permits.vue?vue&type=style&index=0&id=a0558ad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0558ad8",
  null
  
)

export default component.exports